"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = exports.useCurrentRoute = exports.getTargetPageData = exports.getOpenMethod = exports.getRouterLink = exports.Translation = exports.Trans = exports.useTranslation = exports.useLanguageUrls = exports.getOriginPageProp = exports.useOrigin = exports.createOriginProp = exports.languageCookieName = exports.languageList = exports.languageDefault = exports.createBootstrapApp = exports.createComposeAppFn = void 0;
var BootstrapApp_1 = require("./BootstrapApp");
Object.defineProperty(exports, "createComposeAppFn", { enumerable: true, get: function () { return BootstrapApp_1.createComposeAppFn; } });
Object.defineProperty(exports, "createBootstrapApp", { enumerable: true, get: function () { return BootstrapApp_1.createBootstrapApp; } });
var libs_language_1 = require("@hotelplan/libs.language");
Object.defineProperty(exports, "languageDefault", { enumerable: true, get: function () { return libs_language_1.languageDefault; } });
Object.defineProperty(exports, "languageList", { enumerable: true, get: function () { return libs_language_1.languageList; } });
Object.defineProperty(exports, "languageCookieName", { enumerable: true, get: function () { return libs_language_1.languageCookieName; } });
var libs_origin_1 = require("@hotelplan/libs.origin");
Object.defineProperty(exports, "createOriginProp", { enumerable: true, get: function () { return libs_origin_1.createOriginProp; } });
Object.defineProperty(exports, "useOrigin", { enumerable: true, get: function () { return libs_origin_1.useOrigin; } });
Object.defineProperty(exports, "getOriginPageProp", { enumerable: true, get: function () { return libs_origin_1.getOriginPageProp; } });
var libs_language_urls_1 = require("@hotelplan/libs.language-urls");
Object.defineProperty(exports, "useLanguageUrls", { enumerable: true, get: function () { return libs_language_urls_1.useLanguageUrls; } });
__exportStar(require("@hotelplan/libs.router-config"), exports);
var next_i18next_1 = require("next-i18next");
Object.defineProperty(exports, "useTranslation", { enumerable: true, get: function () { return next_i18next_1.useTranslation; } });
Object.defineProperty(exports, "Trans", { enumerable: true, get: function () { return next_i18next_1.Trans; } });
Object.defineProperty(exports, "Translation", { enumerable: true, get: function () { return next_i18next_1.Translation; } });
var libs_router_link_utils_1 = require("@hotelplan/libs.router-link-utils");
Object.defineProperty(exports, "getRouterLink", { enumerable: true, get: function () { return libs_router_link_utils_1.getRouterLink; } });
Object.defineProperty(exports, "getOpenMethod", { enumerable: true, get: function () { return libs_router_link_utils_1.getOpenMethod; } });
Object.defineProperty(exports, "getTargetPageData", { enumerable: true, get: function () { return libs_router_link_utils_1.getTargetPageData; } });
Object.defineProperty(exports, "useCurrentRoute", { enumerable: true, get: function () { return libs_router_link_utils_1.useCurrentRoute; } });
exports.Utils = __importStar(require("@hotelplan/libs.utils"));
__exportStar(require("@hotelplan/libs.hooks"), exports);
__exportStar(require("@hotelplan/libs.hooks-dom"), exports);
__exportStar(require("@hotelplan/libs.hooks-react"), exports);
//# sourceMappingURL=index.js.map